export const trustBadges = [
  {
    id: "safe",
    icon: "ri-shield-check-line",
    title: "Cadastur",
    subtitle: "Embarcações Homologadas",
  },
  {
    id: "rating",
    icon: "ri-star-fill",
    title: "4,9 de 5 estrelas",
    subtitle: "Avaliações dos clientes",
  },
  {
    id: "years",
    icon: "ri-calendar-check-line",
    title: "+12 anos",
    subtitle: "De experiência em Capitólio",
  },
  {
    id: "clients",
    icon: "ri-user-heart-line",
    title: "+10.000 clientes",
    subtitle: "Atendidos com satisfação",
  },
];

export const tours = [
  {
    id: "compartilhado",
    name: "Passeio Compartilhado",
    icon: "ri-group-line",
    priceLabel: "A partir de R$ 100",
    priceNote: "por pessoa",
    featured: false,
    description:
      "Viva o Mar de Minas a bordo de nossas lanchas, em grupo, pelos principais atrativos de Capitólio com conforto e segurança.",
    includes: [
      "3 horas de passeio",
      "Visita aos principais pontos",
      "Passeio em grupo",
      "Ótimo custo-benefício",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Group%20of%20happy%20tourists%20enjoying%20a%20boat%20ride%20on%20turquoise%20lake%20water%20with%20canyon%20cliffs%20in%20Capitolio%20Brazil%2C%20sunny%20day%2C%20warm%20golden%20light%2C%20travel%20photography%2C%20high%20detail&width=800&height=600&seq=eco-tour-compartilhado-v3&orientation=landscape",
  },
  {
    id: "exclusivo",
    name: "Passeio Exclusivo",
    icon: "ri-vip-crown-line",
    priceLabel: "A partir de R$ 700",
    priceNote: "por lancha",
    featured: true,
    description:
      "Uma experiência privativa para a sua família ou grupo, com roteiro e horário de saída totalmente personalizados.",
    includes: [
      "Roteiro personalizado",
      "Horário de saída a sua escolha",
      "Ideal para famílias e grupos",
      "Mais conforto e exclusividade",
    ],
    image:
      "https://readdy.ai/api/search-image?query=Private%20luxury%20speedboat%20cruising%20turquoise%20lake%20water%20past%20tall%20rocky%20canyon%20cliffs%20in%20Capitolio%20Brazil%2C%20golden%20sunset%20light%2C%20elegant%20travel%20photography%2C%20high%20detail&width=800&height=600&seq=eco-tour-exclusivo-v3&orientation=landscape",
  },
];

export const attractions = [
  {
    id: "canyons",
    icon: "ri-landscape-line",
    title: "Cânions",
    description: "Paredões rochosos imponentes que rendem as melhores fotos do passeio.",
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/bd41190ddd61365610701b4e77a1b8e7.jpeg",
  },
  {
    id: "lagoa-azul",
    icon: "ri-water-flash-line",
    title: "Lagoa Azul",
    description: "Águas cristalinas em tom azul-turquesa, um dos cartões-postais de Capitólio.",
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/48918e557a883f272772a4c36c5dda87.jpeg",
  },
  {
    id: "vale-dos-tucanos",
    icon: "ri-leaf-line",
    title: "Vale dos Tucanos",
    description: "Recanto cercado de natureza, com tucanos e paisagens de tirar o fôlego.",
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/88c6d614b4e2dd1868fb830a4d8e3a2a.jpeg",
  },
  {
    id: "cachoeira-da-gruta",
    icon: "ri-drop-line",
    title: "Cachoeira da Gruta",
    description: "Queda d'água escondida entre paredões de pedra, com banho em águas cristalinas.",
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/71a20f555e9d7ab82d34ed62374259ba.jpeg",
  },
  {
    id: "bares-flutuantes",
    icon: "ri-restaurant-line",
    title: "Bares Flutuantes",
    description: "Estruturas sobre o lago para relaxar, comer e beber à beira da água.",
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/31d3b346618e486029d4fa265d7c1660.png",
  },
  {
    id: "parada-para-banho",
    icon: "ri-account-circle-line",
    title: "Parada para Banho",
    description: "Momento exclusivo para mergulhar e refrescar nas águas do Lago de Furnas.",
    image:
      "https://readdy.ai/api/search-image?query=People%20swimming%20and%20relaxing%20in%20clear%20turquoise%20lake%20water%20near%20canyon%20cliffs%20in%20Brazil%2C%20sunny%20day%2C%20travel%20photography&width=400&height=300&seq=eco-att-banho-v3&orientation=landscape",
  },
];

export const fleet = [
  {
    id: "lake-hunter",
    name: "Lake Hunter",
    capacity: "14 passageiros",
    icon: "ri-sailboat-line",
    description:
      "Escolha certa para grupos médios que querem explorar os cânions com conforto — e ainda assar um churrasco a bordo.",
    features: [
      { icon: "ri-bluetooth-line", label: "Som Bluetooth" },
      { icon: "ri-fridge-line", label: "Cooler" },
      { icon: "ri-fire-line", label: "Churrasqueira" },
    ],
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/753722eae528390a97a79bb8866c6692.jpeg",
  },
  {
    id: "val",
    name: "Vall",
    capacity: "15 passageiros",
    icon: "ri-sailboat-line",
    description:
      "Ampla e estável, a mais indicada para famílias e turmas maiores que querem conforto, churrasco e espaço de sobra.",
    features: [
      { icon: "ri-bluetooth-line", label: "Som Bluetooth" },
      { icon: "ri-fridge-line", label: "Cooler" },
      { icon: "ri-fire-line", label: "Churrasqueira" },
    ],
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/89f3bedef1a0837bd6c69ec11ebb3896.jpeg",
  },
  {
    id: "luna",
    name: "Luna",
    capacity: "12 passageiros",
    icon: "ri-sailboat-line",
    description:
      "Aconchegante e espaçosa, a mais indicada para casais e grupos pequenos que buscam um passeio tranquilo e privativo.",
    features: [
      { icon: "ri-bluetooth-line", label: "Som Bluetooth" },
      { icon: "ri-fridge-line", label: "Cooler" },
    ],
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/d005a26d7d040b967b0571c5a60b7c3f.jpeg",
  },
  {
    id: "dream-sea",
    name: "Dream Sea",
    capacity: "19 passageiros + banheiro",
    icon: "ri-ship-2-line",
    description:
      "A maior da frota, com banheiro a bordo e churrasqueira — conforto total para o dia inteiro com o grupo grande e sem aperto.",
    features: [
      { icon: "ri-bluetooth-line", label: "Som Bluetooth" },
      { icon: "ri-fridge-line", label: "Cooler" },
      { icon: "ri-fire-line", label: "Churrasqueira" },
    ],
    image:
      "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/70dd17502845a3544895db9af7128fbc.jpeg",
  },
];

export const jetSkiImage =
  "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/8c3853ce69a450e4ff959e42928dfa37.png";

export const offRoadImage =
  "https://readdy.ai/api/search-image?query=Realistic%20photograph%20of%20a%20black%20Mitsubishi%20Pajero%20Full%20SUV%20driving%20through%20a%20shallow%20crystal-clear%20transparent%20stream%20on%20a%20rocky%20dirt%20trail%20in%20Capit%C3%B3lio%20Minas%20Gerais%20Brazil%2C%20water%20splashing%20around%20the%20tires%2C%20lush%20green%20forest%20and%20mountains%20in%20the%20background%2C%20bright%20natural%20daylight%2C%20ultra%20realistic%20documentary%20travel%20photography%2C%20sharp%20focus%2C%20natural%20colors%2C%20high%20detail&width=800&height=600&seq=eco-tour-4x4-capitolio-v1&orientation=landscape&nocache=true";

export const jetSkiHighlights = [
  {
    id: "guided",
    icon: "ri-compass-3-line",
    title: "Passeio Guiado",
    description: "Saia com instrutor experiente por roteiros seguros e cheios de visual.",
  },
  {
    id: "rental",
    icon: "ri-sailboat-line",
    title: "Locação de Jet Ski",
    description: "Alugue sua moto aquática e explore o Lago de Furnas no seu próprio ritmo.",
  },
  {
    id: "photos",
    icon: "ri-camera-lens-line",
    title: "Fotos e Vídeos",
    description: "Pare em pontos paradisíacos e registre cada momento do passeio.",
  },
];

export const splashDeckVideo =
  "https://storage.helloreaddy.io/project_files/016a7a75-0a62-4481-b6f8-0bfd54128e96/5242274a-5f02-46d5-8001-4e7c03f2bd72_5A0cc7d038e74a3e98a48977a47bcf79-1.mp4";

export const splashDeckHighlights = [
  {
    id: "floating",
    icon: "ri-water-flash-line",
    title: "Piscina flutuante",
    description: "Boia exclusiva ancorada nas águas do Lago de Furnas.",
  },
  {
    id: "fun",
    icon: "ri-emotion-happy-line",
    title: "Relax e diversão",
    description: "Perfeita para relaxar, se refrescar e curtir em grupo.",
  },
  {
    id: "photos",
    icon: "ri-camera-lens-line",
    title: "Fotos incríveis",
    description: "Cenário único para registrar momentos inesquecíveis.",
  },
];

export const boardingImage =
  "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/cee05ddb12967be36460878d5aead191.png";

export const boardingHighlights = [
  {
    id: "parking",
    icon: "ri-parking-box-line",
    title: "Estacionamento gratuito",
    description: "Deixe o carro sem se preocupar e embarque com tranquilidade.",
  },
  {
    id: "locker",
    icon: "ri-door-open-line",
    title: "Vestiário amplo e limpo",
    description: "Espaço confortável e higienizado para você se trocar com calma.",
  },
  {
    id: "infra",
    icon: "ri-building-4-line",
    title: "Infraestrutura completa",
    description: "Toda a estrutura necessária antes e depois do seu passeio.",
  },
  {
    id: "safety",
    icon: "ri-shield-star-line",
    title: "Embarque seguro",
    description: "Área organizada e equipe acompanhando o embarque do início ao fim.",
  },
];

export const features = [
  {
    id: "safety",
    icon: "ri-shield-check-line",
    title: "Segurança em primeiro lugar",
    description:
      "Embarcações regulamentadas, equipamentos de segurança e equipe náutica experiente.",
  },
  {
    id: "comfort",
    icon: "ri-ship-line",
    title: "Frota moderna e confortável",
    description:
      "Lanchas preparadas com conforto e estrutura para você aproveitar cada minuto do passeio.",
  },
  {
    id: "itinerary",
    icon: "ri-route-line",
    title: "Roteiros no Lago de Furnas",
    description:
      "Conheça cânions, cachoeiras, lagoas, bares flutuantes e paradas para banho em um só passeio.",
  },
];

export const allReviews = [
  {
    id: "gr-roberta",
    name: "Roberta Bertagnon",
    location: "Guia Local no Google",
    source: "google",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUb5HtuBui1rzkqOsASHaLrWrKovmFmiJeMJIZ7XiSHw2v7bjx9kw=w72-h72-p-rp-mo-ba12-br100",
    date: "há 9 meses",
    quote:
      "Tudo foi muito bem organizado, desde o primeiro contato. A Carmen me tratou muito bem e respondeu todas as minhas (muitas) perguntas pelo WhatsApp, com rapidez e cordialidade.",
  },
  {
    id: "gr-florida",
    name: "Flórida Mali",
    location: "Guia Local no Google",
    source: "google",
    avatar:
      "https://lh3.googleusercontent.com/a-/ALV-UjUe5jZmLomX9liI_TdsS06_QAWNgWmfnVCaxVzjmF-qUlw1Ahak=w72-h72-p-rp-mo-ba12-br100",
    date: "há 8 meses",
    quote:
      "O passeio de lancha em Capitólio foi simplesmente maravilhoso. Apesar de a lagoa ser artificial, a natureza se revela impressionante nas formações rochosas ao redor, e é possível observar claramente os diferentes tipos de rochas.",
  },
];

export const heroImage =
  "https://static.readdy.ai/image/2b7eadfcd80fca33a6975f7d0c97ecdf/320f75b5b2a2105900614251cb9ece5c.jpeg";

export const foundersImage =
  "https://public.readdy.ai/ai/img_res/edited_2c9ed3a82d8f3cf51ce61703f78f25ab_ec422d76.jpg";